import Button from "@mui/material/Button";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { DialogHeader } from "../../../auth/components/PasswordRecoveryModal";
import { usinasApi } from "../../../services/api";
import { Indicators } from "../types";
import { UsinasContext } from "../context/UsinasContextProvider";
import { useContext, useState } from "react";
export function ConfirmIndicatorsEditModal(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
  setOpenSuccessModal: (open: boolean) => void;
  setOpenErrorModal: (open: boolean) => void;
  indicators: Indicators;
  usinaId: string;
}) {
  const { open, setOpen, indicators, usinaId } = props;
  const { setUsina } = useContext(UsinasContext);
  const [isLoading, setIsloading] = useState(false);
  const onClose = () => setOpen(false);
  const onConfirm = async () => {
    setIsloading(true);
    try {
      console.log("indicators", indicators);
      await usinasApi.patchIndicators(usinaId, indicators);
      const usina = await usinasApi.getUsina(usinaId);
      setUsina(usina);
      setOpen(false);
      props.setOpenSuccessModal(true);
    } catch {
      setOpen(false);
      props.setOpenErrorModal(true);
    }
    setIsloading(false);
  };
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader id="customized-dialog-title" onClose={onClose}>
        Confirmar Edição de Indicadores
      </DialogHeader>
      <DialogContent
        sx={{
          height: "100px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
        dividers
      >
        <Typography gutterBottom>
          A edição dos dados de indicadores irão afetar no cálculo de
          indicadores, deseja confirmar?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar edição</Button>
        <Button
          disabled={isLoading}
          variant="contained"
          color="primary"
          onClick={onConfirm}
        >
          Confirmar Edição
        </Button>
      </DialogActions>
    </Dialog>
  );
}
